/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Place_WordsInputs */

const en_us2_search_field_place_words = /** @type {(inputs: Search_Field_Place_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`home gym place`)
};

const pt_br2_search_field_place_words = /** @type {(inputs: Search_Field_Place_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`casa academia local`)
};

const es_419_search_field_place_words = /** @type {(inputs: Search_Field_Place_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`casa gimnasio lugar`)
};

const pt_pt2_search_field_place_words = /** @type {(inputs: Search_Field_Place_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`casa ginasio local sitio`)
};

const fr_fr2_search_field_place_words = /** @type {(inputs: Search_Field_Place_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`maison salle lieu`)
};

const de_de2_search_field_place_words = /** @type {(inputs: Search_Field_Place_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zuhause studio fitnessstudio ort`)
};

const it_it2_search_field_place_words = /** @type {(inputs: Search_Field_Place_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`casa palestra luogo`)
};

/**
* | output |
* | --- |
* | "home gym place" |
*
* @param {Search_Field_Place_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_place_words = /** @type {((inputs?: Search_Field_Place_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Place_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_place_words(inputs)
	if (locale === "es-419") return es_419_search_field_place_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_place_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_place_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_place_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_place_words(inputs)
	return en_us2_search_field_place_words(inputs)
});
export { search_field_place_words as "search.field_place_words" }